import { CreditGauge } from "../projects/CreditGauge";
import { MobileRefreshButton } from "./MobileRefreshButton";

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-10 h-14 w-full border-b border-border bg-card px-4 flex justify-between items-center">
      {children}
      <div className="flex shrink-0 items-center">
        <CreditGauge variant="header" />
        <MobileRefreshButton />
      </div>
    </header>
  );
};

export default MobileHeader;
